module.exports = __webpack_public_path__ + "fonts/Shekari-Font-Regular.92ebec3.ttf";